/* CREU 20-10 · Galeria por variante.
   Si las variantes tienen foto propia y hay una variante elegida (?variant= al
   entrar, la elegida por defecto, o al cambiar de opcion), la galeria muestra la
   foto de esa variante, despues las fotos que no son de ninguna variante (la de
   modelo, etc.) y oculta las fotos de las otras variantes. Contador "1 / N" y
   linea de progreso cuentan solo lo visible.
   Fotos de modelo solo para ciertos colores: metafield custom.fotos_color
   ({"archivo.jpg": ["Azul","Beige"]}), que el tema deja en #creu-fotos-color.
   Productos sin fotos por variante: no se toca nada. */
(function () {
  'use strict';

  function key(src) {
    if (!src) return '';
    var s = String(src).split('?')[0].split('#')[0];
    s = s.substring(s.lastIndexOf('/') + 1);
    // Sufijos de tamano antiguos de Shopify (foto_1400x.jpg, foto_200x300_crop_center.jpg)
    s = s.replace(/_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(_crop_[a-z]+)?(@\dx)?(?=\.[a-z0-9]+$)/i, '');
    return s.toLowerCase();
  }

  var fotosColor = {};
  try {
    var fc = document.getElementById('creu-fotos-color');
    if (fc) {
      var raw = JSON.parse(fc.textContent) || {};
      Object.keys(raw).forEach(function (k) {
        fotosColor[key(k)] = (raw[k] || []).map(function (x) { return String(x).toLowerCase().trim(); });
      });
    }
  } catch (e) {}

  function init(gallery) {
    if (gallery.__creuVarGal) return;
    gallery.__creuVarGal = true;

    var root = gallery.closest('.shopify-section') || gallery.closest('.creu-product') || document;
    var vEl = root.querySelector('[data-creu-variants]');
    var vform = root.querySelector('.creu-product__form');
    if (!vEl || !vform) return;
    var variants;
    try { variants = JSON.parse(vEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var items = Array.prototype.slice.call(gallery.querySelectorAll('.creu-gallery__item'));
    if (items.length < 2) return;

    // Mapa variante -> slide
    var itemByKey = {};
    items.forEach(function (it) {
      var img = it.querySelector('img');
      if (img) itemByKey[key(img.getAttribute('src'))] = it;
    });
    var variantItem = {};
    var variantKeys = {};
    var variantById = {};
    var n = 0;
    variants.forEach(function (v) {
      variantById[String(v.id)] = v;
      var k = key(v.image);
      if (k && itemByKey[k]) { variantItem[String(v.id)] = itemByKey[k]; variantKeys[k] = true; n++; }
    });
    if (!n) return; // Sin fotos por variante: comportamiento de siempre

    var isVariantItem = function (it) {
      var img = it.querySelector('img');
      return !!(img && variantKeys[key(img.getAttribute('src'))]);
    };

    // Foto de modelo limitada a ciertos colores
    function fotoValeParaVariante(it, variantId) {
      var img = it.querySelector('img');
      var lista = img ? fotosColor[key(img.getAttribute('src'))] : null;
      if (!lista) return true;
      var v = variantById[String(variantId)];
      if (!v) return true;
      var opts = (v.options || [v.option1, v.option2, v.option3]).filter(Boolean).map(function (x) { return String(x).toLowerCase().trim(); });
      if (!opts.length && v.title) opts = String(v.title).toLowerCase().split(' / ').map(function (x) { return x.trim(); });
      for (var i = 0; i < lista.length; i++) { if (opts.indexOf(lista[i]) !== -1) return true; }
      return false;
    }

    // Estado original para poder volver
    var origClass = gallery.className;
    var hadPattern = gallery.classList.contains('creu-gallery--pattern');
    var fullByPos = items.map(function (it) { return it.classList.contains('creu-gallery__item--full'); });
    var mainImg = gallery.querySelector('.creu-gallery__img');
    var mainSrc = mainImg ? mainImg.getAttribute('src') : null;
    var mainSrcset = mainImg ? mainImg.getAttribute('srcset') : null;
    var origLoading = items.map(function (it) { var i = it.querySelector('img'); return i ? i.getAttribute('loading') : null; });

    var media = gallery.parentElement;
    var counterEl = root.querySelector('[data-creu-gallery-current]');
    var totalNode = null;
    if (counterEl) {
      var nx = counterEl.nextSibling;
      while (nx && nx.nodeType !== 3) nx = nx.nextSibling;
      totalNode = nx;
    }
    var origTotal = totalNode ? totalNode.nodeValue : null;
    var segs = Array.prototype.slice.call(root.querySelectorAll('[data-creu-gallery-seg]'));
    var idInput = vform.querySelector('[data-creu-variant-input]');

    var active = false;
    var current = null;

    function visibleItems() {
      return Array.prototype.slice.call(gallery.querySelectorAll('.creu-gallery__item')).filter(function (it) {
        return it.style.display !== 'none';
      });
    }

    function restoreMainImg() {
      if (!mainImg) return;
      if (mainImg.getAttribute('src') !== mainSrc) mainImg.setAttribute('src', mainSrc);
      if (mainSrcset && mainImg.getAttribute('srcset') !== mainSrcset) mainImg.setAttribute('srcset', mainSrcset);
    }

    function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

    function indexVisible(vis) {
      var horizontal = isMobile();
      var mid = horizontal
        ? gallery.scrollLeft + gallery.clientWidth / 2
        : gallery.scrollTop + gallery.clientHeight / 2;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < vis.length; i++) {
        var c = horizontal
          ? vis[i].offsetLeft + vis[i].offsetWidth / 2
          : vis[i].offsetTop + vis[i].offsetHeight / 2;
        var d = Math.abs(c - mid);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    // Pinta contador y linea sobre lo visible (corre despues del pintado del tema)
    function paint() {
      if (!active) return;
      var vis = visibleItems();
      var i = indexVisible(vis);
      if (counterEl) counterEl.textContent = i + 1;
      if (totalNode) totalNode.nodeValue = ' / ' + vis.length + ' ';
      segs.forEach(function (s, k) {
        s.style.display = k < vis.length ? '' : 'none';
        s.classList.toggle('is-active', k === i);
      });
    }
    var raf = null;
    function onScroll() {
      if (!active || raf !== null) return;
      raf = requestAnimationFrame(function () { raf = null; paint(); });
    }
    gallery.addEventListener('scroll', onScroll, { passive: true });
    if (media && media !== gallery) media.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    function scrollStart() {
      try { gallery.scrollTo({ left: 0, top: 0 }); } catch (e) { gallery.scrollLeft = 0; gallery.scrollTop = 0; }
    }

    function reset() {
      if (!active) return;
      active = false;
      current = null;
      items.forEach(function (it, k) {
        it.style.display = '';
        it.classList.toggle('creu-gallery__item--full', fullByPos[k]);
        var img = it.querySelector('img');
        if (img) { if (origLoading[k]) img.setAttribute('loading', origLoading[k]); else img.removeAttribute('loading'); }
        gallery.appendChild(it);
      });
      gallery.className = origClass;
      if (totalNode) totalNode.nodeValue = origTotal;
      segs.forEach(function (s) { s.style.display = ''; });
      scrollStart();
      // El tema repinta el contador al hacer scroll
      window.dispatchEvent(new Event('resize'));
    }

    function apply(variantId) {
      var own = variantItem[String(variantId)];
      if (!own) { restoreMainImg(); reset(); return; }
      restoreMainImg();
      if (active && current === own) { paint(); return; }
      var order = [own];
      var hidden = [];
      items.forEach(function (it) {
        if (it === own) return;
        if (isVariantItem(it) || !fotoValeParaVariante(it, variantId)) hidden.push(it); else order.push(it);
      });
      order.forEach(function (it, pos) {
        it.style.display = '';
        if (hadPattern) it.classList.toggle('creu-gallery__item--full', !!fullByPos[pos]);
        gallery.appendChild(it);
      });
      hidden.forEach(function (it) { it.style.display = 'none'; gallery.appendChild(it); });
      var firstImg = own.querySelector('img');
      if (firstImg) firstImg.setAttribute('loading', 'eager');
      // Con 1 o 2 fotos el tema usa la columna simple; se hace igual aqui
      if (hadPattern) {
        var single = order.length <= 2;
        gallery.classList.toggle('creu-gallery--single', single);
        gallery.classList.toggle('creu-gallery--pattern', !single);
      }
      active = true;
      current = own;
      scrollStart();
      paint();
      requestAnimationFrame(paint);
    }

    // Cambio de opcion: el tema escucha antes (cambia el id y la primera foto);
    // aqui se corre despues y se reordena.
    vform.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      setTimeout(function () {
        var id = idInput ? idInput.value : null;
        if (id) apply(id);
      }, 0);
    });

    // Entrada con ?variant=, o sin el con la variante elegida por defecto (Alba 20-10)
    var param = null;
    try { param = new URLSearchParams(window.location.search).get('variant'); } catch (e) {}
    if (param && variantItem[String(param)]) apply(param);
    else if (idInput && idInput.value && variantItem[String(idInput.value)]) apply(idInput.value);
  }

  function run() {
    document.querySelectorAll('[data-creu-gallery]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
